import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core/'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1
  },
  formControl: {
    marginBottom: 16,
    minWidth: 230,
    flexGrow: 1
  },
  selectEmpty: {
    marginTop: 16
  },
  select: {
    textAlign: 'left'
  }
}

class SimpleSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value || '',
      name: ''
    }
  }

  handleChange = event => {
    const value = event.target.value
    this.setState({ value })
    if (typeof this.props.onChange === 'function') this.props.onChange(value)
  }

  render() {
    const { classes, label, options } = this.props
    let parsedOptions = options
    if (typeof options[0] === 'string') {
      parsedOptions = options.map(d => {
        return {
          value: d,
          label: d
        }
      })
    }
    let name = ''
    if (label) name = label.toLowerCase()

    return (
      <form className={classes.root} autoComplete="off">
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor={`${name}-simple`}>{label}</InputLabel>
          <Select
            className={classes.select}
            value={this.state.value}
            onChange={this.handleChange}
            inputProps={{
              name,
              id: `${name}-simple`
            }}
          >
            {parsedOptions.map((option, i) => {
              const { value, label } = option
              return (
                <MenuItem value={value} key={i}>
                  {label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </form>
    )
  }
}

SimpleSelect.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(SimpleSelect)
